/*
 * Public API Surface of ngx-lib/size-detector
 */
export * from './size-detector.module';
export * from './size-detector.component';
